import { useState } from 'react';
import { useLocation } from 'wouter';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { Button, Input, Label, Card, CardHeader, CardTitle, CardContent } from '../../ui';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAdminAuth();
  const [, navigate] = useLocation();

  // Redirect if already logged in
  if (isAuthenticated) {
    navigate('/admin');
    return null;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);
    setLoading(false);

    if (result.success) {
      navigate('/admin');
    } else {
      setError(result.error || 'Login failed');
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundImage: "url('/assets/shared/simple-bg.png')", backgroundSize: 'cover', backgroundAttachment: 'fixed' }}>
      {/* Same blue header ribbon as website, logo only */}
      <header className="shadow-md" style={{ backgroundColor: '#1356a6' }}>
        <div className="w-full pl-3 pr-6 lg:pl-4 lg:pr-12 flex h-16 items-center">
          <img
            src="/assets/logo/aiscendus-blue-bg.png"
            alt="AIscendus Logo"
            className="h-12 w-auto rounded-lg"
          />
        </div>
      </header>

      {/* Login form */}
      <div className="flex items-center justify-center pt-24">
        <Card className="w-full max-w-md mx-4 shadow-lg">
          <CardHeader className="text-center pb-4">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full" style={{ backgroundColor: 'rgba(19, 86, 166, 0.1)' }}>
              <svg className="h-7 w-7" style={{ color: '#1356a6' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <CardTitle className="text-2xl">Admin Login</CardTitle>
            <p className="text-sm text-muted-foreground mt-1">AIscendus Website Administration</p>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="rounded-md bg-red-50 border border-red-200 p-3 text-sm text-red-700">
                  {error}
                </div>
              )}

              <div className="space-y-2">
                <Label htmlFor="username">Username</Label>
                <Input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter username"
                  required
                  autoFocus
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  required
                />
              </div>

              <Button
                type="submit"
                className="w-full"
                style={{ backgroundColor: '#1356a6' }}
                disabled={loading || !username || !password}
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
